
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { MessageSquare } from 'lucide-react';

interface ChatbotCardProps {
  id: string;
  name: string;
  description: string;
  tags: string[];
  avatarUrl: string;
  conversations: number;
}

const ChatbotCard = ({
  id,
  name,
  description,
  tags,
  avatarUrl,
  conversations
}: ChatbotCardProps) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Card 
      className="chatbot-card overflow-hidden group h-full flex flex-col"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div 
        className="h-36 w-full bg-cover bg-center transition-transform duration-700 ease-out"
        style={{ 
          backgroundImage: `url(${avatarUrl})`,
          transform: isHovered ? 'scale(1.05)' : 'scale(1)'
        }}
      />
      
      <CardHeader className="pt-5 pb-2">
        <CardTitle className="font-display text-xl">{name}</CardTitle>
        <CardDescription className="line-clamp-2">{description}</CardDescription>
      </CardHeader>
      
      <CardContent className="pb-2 flex-grow">
        <div className="flex flex-wrap gap-2 mt-2">
          {tags.map((tag) => (
            <Badge key={tag} variant="secondary" className="rounded-full">
              {tag}
            </Badge>
          ))}
        </div>
      </CardContent>
      
      <CardFooter className="pt-2 flex justify-between items-center border-t border-border mt-auto">
        <div className="flex items-center space-x-2 text-sm text-muted-foreground">
          <MessageSquare size={16} />
          <span>{conversations} conversations</span>
        </div>
        
        <Link to={`/chat/${id}`}>
          <Button 
            variant="ghost" 
            className="rounded-full transition-all duration-300 group-hover:bg-primary group-hover:text-primary-foreground"
          >
            Chat Now
          </Button>
        </Link>
      </CardFooter>
    </Card>
  );
};

export default ChatbotCard;
